import { TAdFoxLazyLoad } from '@cian/adfox-component';

export const ADFOX_LAZY_LOAD: TAdFoxLazyLoad = {
  fetchMargin: 0.5,
  mobileScaling: 1,
};

export const BANNER_SIZES = {
  width: '100%',
  minHeight: '200px',
};

export const BASE_PARAMS = {
  pct: 'b',
  pfb: 'a',
  pfc: 'a',
  pli: 'a',
  plp: 'a',
  pop: 'a',
};

export const BANNER_PARAMS = {
  footer: {
    p1: 'cqvyb',
    p2: 'fkhh',
  },
};
